import { UTCDate } from '@date-fns/utc';
import { Row } from '@tanstack/react-table';
import { format } from 'date-fns';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from '../../../../design-system/form/form-primitives';
import { AccountView } from '../../../../types/entity-types';
import { cn } from '../../../../utils/cn';
import { AccountMappingFormValues } from './account-mapping-form';
import { DatePicker } from './date-picker';

const DATE_FORMAT = 'yyyy-MM-dd';

type FromDateFormFieldProps = {
  row: Row<AccountView>;
};

export const FromDateFormField = ({ row }: FromDateFormFieldProps) => {
  const { control, getValues, trigger } = useFormContext<AccountMappingFormValues>();

  const idx = getValues('accounts').findIndex((a) => a.accountId === row.original.id);

  if (idx === -1) {
    return null;
  }

  const fieldPath = `accounts.${idx}.fromDate` as const;

  return (
    <FormField
      control={control}
      name={fieldPath}
      render={({ field, fieldState }) => {
        const dateValue = field.value ? new UTCDate(field.value) : undefined;

        return (
          <FormItem className="relative">
            <FormControl>
              <DatePicker
                value={dateValue}
                onTogglePopover={(open) => {
                  if (!open) {
                    field.onBlur();

                    if (!field.value) {
                      trigger(fieldPath);
                    }
                  }
                }}
                onChangeValue={(d) => field.onChange(format(d, DATE_FORMAT))}
                className={cn({ 'border-seapoint-red': !!fieldState.error })}
              />
            </FormControl>

            <FormMessage className="absolute right-5 top-[0.5px] w-full text-right text-[10px] font-normal" />
          </FormItem>
        );
      }}
    />
  );
};
